import React from 'react';

import { css } from '@emotion/css';
import { DailyWorkflowRuleInfoDTO } from '@recurrency/core-api-schema/dist/dailyWorkflow/getDailyWorkflowTasks';
import { theme } from 'theme';

import { FlexSpace } from 'components/FlexSpace';
import { DailyWorkflowRuleCollapsedTooltip } from 'components/Tooltip/DailyWorkflowRuleCollapsedTooltip';

import { getWorkflowBucketColor } from './DailyWorkflowBuckets';
import { WorkflowReviewProgress } from './utils';

interface CollapsedDailyWorkflowBucketsProps {
  tasks: DailyWorkflowRuleInfoDTO[];
  reviewProgress: WorkflowReviewProgress;
  selectedRuleId: string;
  setSelectedRuleId: (ruleId: string) => void;
  setSelectedIndex: (index: number) => void;
}

export const CollapsedDailyWorkflowBuckets = ({
  tasks,
  reviewProgress,
  selectedRuleId,
  setSelectedRuleId,
  setSelectedIndex,
}: CollapsedDailyWorkflowBucketsProps) => (
  <FlexSpace wrap fullWidth gap={0} direction="column">
    {tasks.map((task, i) => {
      const taskInfo = reviewProgress.items[task.ruleId];
      const reviewedItemsCount = taskInfo?.reviewedItemsCount || 0;
      const taskColor = getWorkflowBucketColor(i);
      const isTaskDisabled = taskInfo?.areAllItemsSubmitted || reviewProgress.totalItemsCount === 0;

      return (
        <div
          key={task.ruleId}
          onClick={() => {
            if (isTaskDisabled) return;
            setSelectedRuleId(task.ruleId);
            setSelectedIndex(0);
          }}
        >
          <FlexSpace
            direction="column"
            gap={0}
            alignItems="center"
            justify="center"
            className={css`
              cursor: pointer;
              width: 50px;
              height: 50px;
              border-radius: 8px;
              border: 2px solid ${theme.colors.neutral[300]};
              margin-top: 40px;

              // Selected rule style
              ${selectedRuleId === task.ruleId && `border-color: ${theme.colors.success[500]}`}

              // Disabled rule style
              ${isTaskDisabled &&
              `
                background-color: ${theme.colors.neutral[75]};
                cursor: default;
                opacity: 0.6;
              `}
            `}
          >
            <DailyWorkflowRuleCollapsedTooltip task={task} color={taskColor} reviewedItemsCount={reviewedItemsCount}>
              <FlexSpace direction="column" alignItems="center" justify="center" gap={2}>
                <span
                  className={css`
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 16px;
                  `}
                >
                  {task.taskCount}
                </span>
                <span
                  className={css`
                    line-height: 10px;
                    font-size: 26px;
                    color: ${taskColor};
                  `}
                >
                  •
                </span>
              </FlexSpace>
            </DailyWorkflowRuleCollapsedTooltip>
          </FlexSpace>
        </div>
      );
    })}
  </FlexSpace>
);
